import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "1",
    title: "Detect",
    text: "WSafe AI watches your existing CCTV and phone cameras and describes possible hazards in plain language. EnviSafe adds site conditions; SafeForm adds ergonomic findings.",
  },
  {
    n: "2",
    title: "Triage & act",
    text: "A competent person confirms or dismisses. InductIQ checks the crew and runs AI triage; HazardLoop assigns an owner and escalates until it's handled.",
  },
  {
    n: "3",
    title: "Close out & learn",
    text: "HazardLoop verifies the fix. WorkSafeStory turns the lesson into toolbox content.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-white py-[88px] scroll-mt-16">
      <div className="mx-auto max-w-[1160px] px-6">
        <Chapter
          eyebrow="How it works"
          title="One patent-pending loop. Three steps."
          lede="A person reviews every AI suggestion before anything happens."
        />
        <div className="grid md:grid-cols-3 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="h-full">
              <div
                data-testid={`how-step-${s.n}`}
                className="h-full bg-white border border-line border-t-[3px] border-t-safety rounded-[14px] p-8 shadow-[0_2px_10px_rgba(23,71,95,0.05)]"
              >
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-navy text-white font-extrabold text-lg mb-6">
                  {s.n}
                </span>
                <h3 className="text-xl font-extrabold text-navy mb-3">{s.title}</h3>
                <p className="text-sm text-steel leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
